// extracted by mini-css-extract-plugin
export var body = "_3n-1";
export var bodyPadded = "_3n-2";
export var chevron = "_3n-4";
export var chevronOpen = "_3n-5";
export var header = "_3n-0";
export var icon = "_3n-3";